// eslint-disable-next-line
import React, { FC, ComponentType } from 'react';
import { WizardStateProps, DispatchProps } from './context';

// eslint-disable-next-line
export type WizardStepProps<T> = Required<StepProps> & DispatchProps;

export type WithWizardStepProps<T> = {
  wizard: WizardStepProps<T>;
};

type StepProps = {
  title: string;
  component: ComponentType<any>;
  isActive?: boolean;
  step?: string;
  stepState?: any;
  stepsState?: WizardStateProps;
};

export const WizardStep: FC<StepProps> = ({
  component: Component,
  isActive,
  ...restProps
}) => {
  return <>{isActive && <Component wizard={restProps} />}</>;
};
